import styled, { keyframes } from 'styled-components';

import { tokens } from '../../design/tokens';

interface SkeletonProps {
  animationDelay?: number;
}

/**
 * Varredura de carregamento.
 *
 * Anima `transform`, não `background`. O shimmer anterior repintava a caixa
 * inteira a cada quadro, em até 24 elementos simultâneos na fileira de
 * cursos — num Android antigo isso é a diferença entre um carregamento
 * fluido e um travado. `translateX` roda no compositor.
 */
const sweep = keyframes`
  from { transform: translateX(-100%); }
  to   { transform: translateX(100%); }
`;

export default styled.div<SkeletonProps>`
  position: relative;
  overflow: hidden;
  border-radius: ${tokens.radius.xs};

  /*
   * Tom de repouso. Antes a cor existia SÓ dentro dos keyframes, terminando
   * em rgba(61,61,61,0) — transparente. Sob prefers-reduced-motion o
   * animation-iteration-count: 1 de global.ts congela a animação nesse
   * quadro final, então o esqueleto sumia e quem pede menos movimento via
   * tela em branco no lugar do carregamento (ver 3c134cb no ROLLBACK_LOG).
   * Com fundo próprio, a silhueta existe mesmo sem animação nenhuma.
   *
   * #222222 é o degrau tonal do card em DESIGN.md, não uma cor nova.
   */
  background: ${tokens.color.cardCharcoal};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* Branco a 6% sobre o degrau tonal — nenhuma cor entra na paleta. */
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.06) 50%,
      rgba(255, 255, 255, 0) 100%
    );

    transform: translateX(-100%);
    animation: ${sweep} 1.4s ease-in-out infinite;
    animation-delay: ${(props) =>
      props.animationDelay ? props.animationDelay : 0}s;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;
